export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4742.c7195cd4.jpg";